import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { selectPayrollExportsKeyedById } from 'services/payrollExports/selectors';
import { OwnProps } from './index';

const selectPayrollExportId = (state: AppState, props: OwnProps): number =>
    props.id;

const selectCreatedBy = createDeepEqualSelector(
    selectPayrollExportId,
    selectPayrollExportsKeyedById,
    (payrollExportId, payrollExportsKeyedById) =>
        get(payrollExportsKeyedById, [payrollExportId, 'createdBy'])
);

const makeSelectCreatedBy = (): typeof selectCreatedBy => selectCreatedBy;

export { selectPayrollExportId, makeSelectCreatedBy };
